import { render } from "./ImportContactImporter.vue?vue&type=template&id=2c24685b"
import script from "./ImportContactImporter.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./ImportContactImporter.vue?vue&type=script&charset=utf-8&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__